import { render, staticRenderFns } from "./temp-info.vue?vue&type=template&id=6c5402f3&scoped=true"
import script from "./temp-info.vue?vue&type=script&lang=js"
export * from "./temp-info.vue?vue&type=script&lang=js"
import style0 from "./temp-info.vue?vue&type=style&index=0&id=6c5402f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5402f3",
  null
  
)

export default component.exports